import React, { useState } from "react";
import { handleOnClickLogout } from "../constants";
import { NavBar, SideBar, Breadcrumb, UnderConstruction } from "../components";
import { AnalyticDashboard } from "../components/analytics";

const Analytics = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [loading, setLoading] = useState(false);
  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={"analytics"} />
        <div className="flex flex-col w-full bg-red-100">
          <Breadcrumb breads={["Analytics"]} />
          <AnalyticDashboard />
        </div>
      </div>
    </div>
  );
};

export default Analytics;
